module.exports = __webpack_public_path__ + "static/Truck32-e8185b1f7d755136ef53691e51296b01.png";